import React from "react";
import styles from "./Step.module.css";
import cx from "classnames";

type Props = {
  stepData: {
    title: string;
    active: boolean;
  }[];
};

const Step = ({ stepData }: Props) => {
  return (
    <div className={styles.container}>
      <ul className={styles.progressbar}>
        {stepData?.map((step) => (
          <li
            key={`${step.title}-key`}
            className={cx(
              step.active ? styles.active : "",
              "font-nunito text-sm"
            )}
          />
        ))}
      </ul>
    </div>
  );
};

export default Step;
